export default "__VITE_ASSET__CTl3C9bH__"